import { render, staticRenderFns } from "./PlayAsTeamSetUp.vue?vue&type=template&id=6563c69c&scoped=true&"
import script from "./PlayAsTeamSetUp.vue?vue&type=script&lang=js&"
export * from "./PlayAsTeamSetUp.vue?vue&type=script&lang=js&"
import style0 from "./PlayAsTeamSetUp.vue?vue&type=style&index=0&id=6563c69c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563c69c",
  null
  
)

export default component.exports